import { isArray, isEmpty } from 'lodash';

/**
 * @param {string} path
 * @returns string
 */
export const getCleanUrlPath = (path: string) => path.replace(/\/$/g, '');

/**
 * @param {string} path
 * @returns string
 */
export const isHttpUrl = (url: string) => {
	return /^(http|https):\/\//.test(url);
};

export const printElement = ({
	elementId = '',
	width = 1500,
	height = 1200,
}) => {
	const printWindow = window.open('', '', `width=${width},height=${height}`);
	const printableContent = document.getElementById(elementId)?.innerHTML;

	printWindow?.document.write(printableContent!);
	printWindow?.document.close();
	printWindow?.focus();
	printWindow?.print();
	setTimeout(() => {
		printWindow?.close();
	}, 5);
};

// Format Amount
export function formatAmount(amount: number | string, isInRupee = false) {
	if (isInRupee) {
		return `₹ ${new Intl.NumberFormat('en-IN').format(+amount)}`;
	}

	const formatAmount = parseFloat((+amount / 100).toString()).toFixed(2);
	const formattedAmount = new Intl.NumberFormat('en-IN').format(+formatAmount);
	return isNaN(+formatAmount) ? '₹ 0' : `₹ ${formattedAmount}`;
}

export const formatTagsData = (tagData: unknown) => {
	if (isEmpty(tagData)) {
		return 'NA';
	}

	if (typeof tagData !== 'object') {
		return tagData;
	}

	if (isArray(tagData)) {
		return tagData.join('|');
	}
};

export const getAmountInPaisa = (amount: string) => {
	const formatAmount = parseInt((Number(amount) * 100).toString());
	return isNaN(formatAmount) ? 0 : formatAmount;
};

export const setTagBeforeEventFiring = <T extends Record<string, number>>(
	extraData: Partial<Record<keyof T, unknown>>,
	tagsMapping: T,
) => {
	type U = T[keyof T];
	const payload: Partial<Record<`t${U}`, unknown>> = {};
	const extraDataKeys = Object.keys(extraData) as (keyof T)[];
	extraDataKeys.forEach((key) => {
		if (key in tagsMapping) {
			payload[`t${tagsMapping[key]}`] = formatTagsData(extraData[key]);
		}
	});
	return payload;
};
